import { SettingLandingClaimInformationContainer } from "../";

export const SettingLandingClaimMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingClaimInformationContainer />
    </div>
  );
};
